import './globals';

/**
 * Get configuration value for this application.
 */
export const getConfig = <L extends keyof typeof CONFIG>(key: L): (typeof CONFIG)[L] => {
    return CONFIG[key];
};
